module.exports = __webpack_public_path__ + "img/hohlsaum_zinkgelb_ral1018.d573961f.jpg";